import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import { FlexBox } from '../../../components/tableItems';
import { MainButton } from '../../../components/buttons';
import { CustomTextAreaField } from '../../../components/inputs';
import WeeklyLogModalParent from './WeeklyLogModalParent';
import useWeeklyLogStore from '../../../stores/weeklyLog/WeeklyLogStore';

interface WeeklyLogNoteModalProps {
  open: boolean;
  closeModal: () => void;
  body: string;
  index: number;
}

const WeeklyLogNoteModal: React.FC<WeeklyLogNoteModalProps> = ({
  open,
  closeModal,
  body,
  index,
}) => {
  const { updateFormWeeklyLog } = useWeeklyLogStore();
  const [value, setValue] = useState('');

  useEffect(() => {
    if (open) {
      setValue(body);
    }
  }, [open]);

  return (
    <WeeklyLogModalParent
      title="Note Preview"
      closeModal={closeModal}
      open={open}
    >
      <Box marginTop={3.5}>
        <CustomTextAreaField
          placeholder="Note"
          minRows={4}
          multiline
          maxRows={Infinity}
          disabled={false}
          required
          helperText=""
          error={false}
          value={value}
          onChange={e => {
            setValue(e.target.value);
          }}
        />
      </Box>

      <Box marginTop={3.5}>
        <FlexBox marginTop={3} justifyContent="center">
          <MainButton
            onClick={() => closeModal()}
            variant="contained"
            sx={{
              backgroundColor: '#F0F0F0',
              color: 'black',
              marginRight: 1,
              '&:hover': {
                backgroundColor: '#F2F2F2',
              },
            }}
          >
            Cancel
          </MainButton>
          <MainButton
            variant="contained"
            onClick={() => {
              updateFormWeeklyLog(index, { notes: value });
              closeModal();
            }}
            disabled={value === ''}
            loading={false}
            sx={{ marginLeft: 1 }}
          >
            Save
          </MainButton>
        </FlexBox>
      </Box>
    </WeeklyLogModalParent>
  );
};

export default WeeklyLogNoteModal;
